import { render, staticRenderFns } from "./UserTableList.vue?vue&type=template&id=2420f701&scoped=true&"
import script from "./UserTableList.vue?vue&type=script&lang=js&"
export * from "./UserTableList.vue?vue&type=script&lang=js&"
import style0 from "./UserTableList.vue?vue&type=style&index=0&id=2420f701&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2420f701",
  null
  
)

export default component.exports